export const patterns = {
	url: new RegExp('^(https?:\\/\\/)?'+ // protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
		'(\\#[-a-z\\d_]*)?$', 'i'), // fragment locator
	extensionsOf: {
		images: /\.(?:jpg|jpeg|png|gif)$/
	}
};

export const isRequired = value => value ? undefined : 'required';
export const isSelected = value => value && value.length ? undefined : 'required';


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form/validation.js